module.exports = __webpack_public_path__ + "media/images/company_1-5977aeec5175bbe0f6bc26a6a154f327.jpg";